import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_API_URL } from "../../../utility/api";

export const clinicAuth = createApi({
  reducerPath: "clinicAuth",
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({

    getClinics: builder.query({
      query: () => `users/clinics?page=1&limit=10`,
      invalidatesTags: ['Clinics'],

    }),

    createClinic: builder.mutation({
      query: (data) => ({
        url: "users/clinics",
        method: "POST",
        body: data,
      }),
    }),

    getClinicDetails:builder.query({
      query:(id)=>`users/clinics/${id}`,
    }),

    updateClinicDetails: builder.mutation({
      query: ({data,id}) => ({
        url: `users/clinics/${id}`,
        method: "PUT",
        body: data,
      }),
    }),

    deleteClinic: builder.mutation({
      query: ( id) => ({
        url: `users/clinics/${id}`,
        method: "DELETE", 
      }),
    }),

    changeClinicStatus: builder.mutation({
      query: ({data,id}) => ({
        url: `users/clinics/${id}/status`,
        method: "PATCH",
        body: data,
      }),
    }),




  }),
});

export const { 
  useGetClinicsQuery,
  useCreateClinicMutation,
  useGetClinicDetailsQuery,
  useUpdateClinicDetailsMutation,
  useDeleteClinicMutation,
  useChangeClinicStatusMutation
 } = clinicAuth;
